import { createSlice } from '@reduxjs/toolkit'
import { ModalTypeProps, ModalTypes, UIState } from './UITypes'

const initialState: UIState = {
  Modals: undefined,
}

const uiSlice = createSlice({
  initialState: initialState,
  name: 'ui',
  reducers: {
    openModal: (
      state,
      action: {
        type: string
        payload: {
          modalType: ModalTypes
          modalProps: ModalTypeProps
        }
      }
    ) => {
      state.Modals = {
        CurrentModal: action.payload.modalType,
        ModalProps: action.payload.modalProps,
      }
    },
    closeModal: (state) => {
      state.Modals = undefined
    },
  },
})

export default uiSlice.reducer
export const uiActions = uiSlice.actions
